module.exports = __webpack_public_path__ + "static/media/veona-introductory-package.924f777f.png";